/* eslint-disable max-len */
import React, { Fragment } from 'react'
import TableBody from './TableBody'
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import { useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { selectAllRows } from '../../../../redux/MultiselectRowsConditionally';
import { useSelector, useDispatch } from 'react-redux';
import SearchEmptyScreen from '../../../../components/SearchEmptyScreen';

const Table = ({ pageNumber, List, handleSearchParams, sortValue, setisSortSelected, setConfirmationState, setTextAreaMsg,handleDelete,loading }) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const [selectedIndex, setSelectedIndex] = useState(null);
    const selectedRef = useRef();
    const selectedRows = useSelector((state) => state.MultiSelectSliceConditionally.selectedRows.topCheckBox)
    const urlParams = new URLSearchParams(window.location.search);
    const branchUrl = urlParams.get('sort');
    const dispatch = useDispatch()
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });

    const handleAllRowsSelect = (event) => {
        const paramstoPass = [event.target.checked, pageNumber.toString(), List.data]
        dispatch(selectAllRows(paramstoPass))

    }

    const handleSort = (key) => {
        setisSortSelected(true)
        if (sortValue === '') handleSearchParams('sort', `${key}+asc`)
        else {
            if (sortValue.includes(key)) handleSearchParams('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleSearchParams('sort', `${key}+asc`)
        }
    }


    return (
        <div>
            <div className='2xl:h-[calc(100vh-215px)] h-[calc(100vh-226px)] ObsTableHeight  overflow-auto scrollbar_purple pb-2.5'>
                <table aria-label="Outside Table" className="w-full table-auto">
                    <thead>
                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-0 left-0 z-[1]">
                            <th className="px-[18px] py-2 rounded-tl-sm rounded-bl-sm">
                                <div className="relative checkbox custom-checkBoxBlue1">
                                    <input type="checkbox" id={pageNumber} data-testid="checkbox" checked={selectedRows?.find(item => item.page_number === pageNumber.toString())?.isChecked ? true : false} onChange={handleAllRowsSelect} />
                                    <label htmlFor={pageNumber} className="text-sm font-normal text-[#031624] w-full cursor-pointer"></label>
                                </div>
                            </th>
                            <th id="id" className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm" onClick={() => { handleSort('user_id') }}>
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">ID
                                    <button className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "user_id" ? `/images/column-sorting_desc.svg` : '/images/column-sorting.svg'} alt="icon" /></button>
                                </span>
                            </th>
                            <th id="username" className="px-[18px] py-2 min-w-[250px] break-all rounded-tl-sm rounded-bl-sm" onClick={() => { handleSort('user_name') }}>
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Username
                                    <button className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "user_name" ? `/images/column-sorting_desc.svg` : '/images/column-sorting.svg'} alt="icon" /></button>
                                </span>
                            </th>
                            <th id="first" className="px-[18px] py-2 min-w-[180px] break-all rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">First Name
                                </span>
                            </th>
                            <th id="last" className="px-[18px] py-2 min-w-[180px] break-all rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Last Name
                                </span>
                            </th>
                            <th id="status" className="px-[18px] py-2  break-all min-w-[120px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Status
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[160px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Alerts by SMS
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[160px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Alerts by Email
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[220px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Include Missed Readings
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[280px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Receive Readings Acknowledgement
                                </span>
                            </th>
                            <th id="status" className="px-[18px] py-2 break-all min-w-[230px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Patient Associated with
                                </span>
                            </th>
                            <th id="status" className="px-[18px] break-all py-2 min-w-[200px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Sub Division Name
                                </span>
                            </th>
                            <th className="px-[18px] py-2 break-all min-w-[250px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Email Address
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[180px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Mobile Number
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[180px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Main Number
                                </span>
                            </th>
                            <th id="create_date" className="px-[18px] py-2 min-w-[200px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Created Date
                                </span>
                            </th>
                            <th className="px-[18px] py-2 rounded-tr-[2px] rounded-br-[2px] sticky top-0 right-[-1px] bg-[#EDD7E1] min-w-[70px]">
                                <span className="flex items-center justify-center text-sm font-normal text-[#000000]">Actions
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {List?.data?.map((item, index) => (
                            <Fragment key={item._id}>
                                <TableBody
                                    tableData={item}
                                    List={List}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List?.data?.length}
                                    setConfirmationState={setConfirmationState}
                                    setTextAreaMsg={setTextAreaMsg}
                                    handleDelete={handleDelete}
                                    loading={loading}
                                />
                            </Fragment>
                        ))}


                    </tbody>

                </table>

            </div>
        </div>
    )
}

export default Table